/*
 * Pulls the overlay's prompts from the Atomz app instead of the theme.
 *
 * The merchant sets them in the app admin under Appearance > Search Bar >
 * Set Default Search Suggestions. The az-search-bar block renders them into
 * the page as:
 *
 *   <animate-text data-text="a,b,c" style="--time:5s">
 *
 * There is no endpoint for this list, so the block has to be present. It is
 * loaded hidden purely as the data source; the visible search entry is the
 * theme's own header field and overlay. Editing the list in the app admin
 * changes the storefront with no theme edit.
 *
 * Self-guards: with no animate-text on the page the theme defaults stand.
 */
(function () {
  'use strict';

  var boot = function () {
    var S = window.AtomzSearch;
    if (!S || !S.overlay) return;

    var src = document.querySelector('animate-text[data-text]');
    if (!src) return;

    var list = (src.getAttribute('data-text') || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);

    if (!list.length) return;

    var overlay = S.overlay;

    /* the typewriter placeholder cycles the merchant's phrases */
    overlay.prompts = list;

    var wrap = overlay.root.querySelector('.az-suggest');
    if (!wrap) return;

    wrap.textContent = '';

    list.slice(0, 6).forEach(function (phrase) {
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'az-suggest__item';
      btn.textContent = phrase;

      /*
       * These are natural-language phrases. query-auto-complete matches
       * product titles and returns nothing for them, so previewing in the
       * overlay would show an empty panel. The results page runs them through
       * query-index, which understands them, so go straight there.
       */
      btn.addEventListener('click', function () {
        window.location.href = '/search?q=' + encodeURIComponent(phrase);
      });

      li.appendChild(btn);
      wrap.appendChild(li);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
